import React, { Component } from 'react'
import { main_menu_list } from '..';
import MainLayout from '../main_layout';
import SideMenu from '../../components/side_menu';
import { Switch } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { Route } from 'react-router-dom';
import DatatypeList from './datatype_list';
import FileList from './files_list';
import { KitchenOutlined, DnsOutlined, InsertDriveFileOutlined, Layers, LayersOutlined, AvTimerOutlined, KeyboardArrowRightOutlined, ArrowDropDownCircle, ArrowDropDownCircleOutlined, WavesOutlined, GridOnOutlined, SdStorageOutlined } from '@material-ui/icons';
import FetcherLogs from './fetcher_logs';
import FetcherResponses from './fetcher_responses';
import PacketList from './packet_list';
import SourcePacketList from './source_packet_list';
import FetcherResponseDetail from './fetcher_response_detail';
import FetcherLogDetail from './fetcher_log_detail';
import FileDetailError from './file_detail_error';
import FileDetailRaw from './file_detail_raw';
import SourceLabelList from './datatype_source_labels';
import CachedDataList from './cached_data_list';
import CachedDataDetail from './cached_data_detail';
import RepositoryList from './repository_list';
import DatatypeConfigList from '../all_data/datatype_configs';
import DatatypeDataList from './datatype_data_list';
import FileNotTransferredTransactions from './file_nottransferred_transactions';
import TableList from './table_list';
import TableDataList from './table_data_list';
import ModalTransactionDetail from '../../components/modal_transaction_detail';
import ModalPacketDetailView from '../../components/modal_packet_detail';
import UnclassifiedTransactionList from './unclassified_transaction_list';
import RefillTable from './refill_table';
import RefillAtmList from './refillATM/list';

class ActivityPage extends Component {
  render() {
    var pathName = this.props.location.pathname + this.props.location.search;
    return (
      <React.Fragment>
        {/* {showTransactionModal&&<div style={{
                position:'absolute',
                top:0,
                zIndex:1000,
                backgroundColor:'#ddd',
                height:'100%',
                width:'100%'
            }}>
            <Route path='/reconciliation/process/:process_id/unreconciled/:transaction_id' component={TransactionDetail} />
            </div>} */}
        <MainLayout
          onRef={(ref) => {
            window.slider_main = ref
          }}
          sliderContent={<SideMenu
            key='sideractivity'
            menuKey={pathName}
            item={[
              {
                type: "main",
                title: "Fetchers",
                key: 'fetcher',
                url: 'activity/fetcher',
                icon: <ArrowDropDownCircleOutlined className='menu-icon' />,
                hasShortcut: true,
                trigger: "Alt+F,Alt+f",
                triggerLabel: "F"
              },
              {
                type: "main",
                title: "Datatypes",
                key: 'data-type',
                url: 'activity/data-type',
                icon: <WavesOutlined className='menu-icon' />,
                hasShortcut: true,
                trigger: "Alt+D,Alt+d",
                triggerLabel: "D"
              },
              {
                type: "main",
                title: "Tables",
                key: 'tables',
                url: 'activity/table',
                icon: <GridOnOutlined className='menu-icon' />,
                hasShortcut: true,
                trigger: "Alt+T,Alt+t",
                triggerLabel: "T"
              },
              {
                type: "main",
                title: "Caches",
                key: 'caches',
                url: 'activity/cache',
                icon: <SdStorageOutlined className='menu-icon' />,
                hasShortcut: true,
                trigger: "Alt+C,Alt+c",
                triggerLabel: "C"
                // iconRight: <KeyboardArrowRightOutlined type='right' style={{}} />
              },
              {
                type: "main",
                title: "Refill Table",
                key: 'refill_table',
                url: 'activity/refill_table',
                icon: <GridOnOutlined className='menu-icon' />,
                hasShortcut: true,
                trigger: "Alt+R,Alt+r",
                triggerLabel: "R"
              },
              {
                type: "main",
                title: "Refill ATM",
                key: 'refill_atm',
                url: 'activity/refill_atm',
                icon: <GridOnOutlined className='menu-icon' />,
                hasShortcut: true,
                trigger: "Alt+A,Alt+a",
                triggerLabel: "A"
              }
            ]}
          />}
          pageTitle="Activity"
          mainContent={<Switch>

            <Route path='/activity/data-type/:datatype_id/nottransferredtransactions' component={FileNotTransferredTransactions} />


            {/* <Route path='/activity/data-type/:datatype_id/config' component={DatatypeConfigList} /> */}
            <Route path='/activity/data-type/:datatype_id/transactions' component={DatatypeDataList} />
            <Route path='/activity/data-type/:datatype_id/unclassifiedtransactions' component={UnclassifiedTransactionList} />

            <Route path='/activity/data-type/:datatype_id/files/:file_id/view' component={FileDetailRaw} />
            <Route path='/activity/data-type/:datatype_id/files/:file_id' component={FileDetailError} />
            <Route path='/activity/data-type/:datatype_id/files' component={FileList} />
            <Route path='/activity/data-type/:datatype_id/packets/:packet_id/detail' component={ModalPacketDetailView} />
            <Route path='/activity/data-type/:datatype_id/packets/forsource' component={SourcePacketList} />
            <Route path='/activity/data-type/:datatype_id/packets' component={PacketList} />
            <Route path='/activity/data-type/:datatype_id/sources' component={SourceLabelList} />

            <Route path='/activity/data-type' component={DatatypeList} />


            <Route path='/activity/table/:table_id' component={TableDataList} />
            <Route path='/activity/table' component={TableList} />
            <Route path='/activity/refill_table' component={RefillTable} />
            <Route path='/activity/refill_atm' component={RefillAtmList} />


            <Route path='/activity/fetcher/logs/:log_id' component={FetcherLogDetail} />
            <Route path='/activity/fetcher/:repository_id/logs' component={FetcherLogs} />
            <Route path='/activity/fetcher/responses/:log_id/:response_id' component={FetcherResponseDetail} />
            <Route path='/activity/fetcher/:repository_id/responses' component={FetcherResponses} />

            <Route path='/activity/fetcher' component={RepositoryList} />
            {/* <Route path='/activity/fetcher-logs/:log_id' component={FetcherLogDetail} />
            <Route path='/activity/fetcher-logs' component={FetcherLogs} />
            <Route path='/activity/fetcher-responses/:log_id/:response_id' component={FetcherResponseDetail} />

            <Route path='/activity/fetcher-responses' component={FetcherResponses} /> */}



            <Route path='/activity/cache/:id' component={CachedDataDetail} />
            <Route path='/activity/cache' component={CachedDataList} />
            <Route path='/activity/:transaction_id'
              render={(props) => {
                return <div style={{
                  margin: 8
                }}><ModalTransactionDetail {...props} /></div>
              }}
            />

            <Redirect from='*' to='/activity/fetcher' />
          </Switch>}
        />
      </React.Fragment>
    );
  }
}

export default ActivityPage
